export const getSmoothWidthScaling = (minWidth: number): string => {
  const scaleFactor = 0.1; // Adjust this factor as needed for smooth scaling
  const scaledWidth = minWidth * scaleFactor;
  return `calc(${minWidth}px + ${scaledWidth} * (100vw - 1365px) / 100)`;
};

export const getSmoothHeightScaling = (minHeight: number): string => {
  const scaleFactor = 0.1; // Adjust this factor as needed for smooth scaling
  const scaledHeight = minHeight * scaleFactor;
  return `calc(${minHeight}px + ${scaledHeight} * (100vh - 768px) / 100)`;
};
